module.exports = __webpack_public_path__ + "img/connect-aws.3361e004.png";